import TYPES from '../product-types';
export default [
    // ************************************************************
    //
    // XS1 Accessory Tree
    //
    // ************************************************************
    {
        id: 'xs1-accessory-tree',
        type: TYPES.XS1_ACCESSORY_TREE
    }
];
